<template>
  <div>
    <Loading v-if="loading && mode === 'edit'" />
    <form @submit.prevent="handleSubmit()" v-else>
      <fieldset class="form-group">
        <label class="form-label">Name</label>
        <input type="text" v-model="form.name" class="form-input">
      </fieldset>
      <fieldset class="form-group">
        <label class="form-label">Email Address</label>
        <input type="email" v-model="form.email" class="form-input">
      </fieldset>
      <fieldset class="form-group">
        <label class="form-label">Cellphone</label>
        <CellphoneInput v-model="form.cellphone" @input="handleCellphoneInput" />
      </fieldset>
      <div class="flex justify-between">
        <button type="submit" class="btn btn-primary" v-submitting="submitting">
          {{ mode === 'create' ? 'Create Contact' : 'Save Changes' }}
        </button>
        <button type="button" class="font-medium text-red-500 hover:underline" @click="deleteContact()" v-submitting="submitting" v-if="mode === 'edit'">
          Delete Contact
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CellphoneInput from '@/components/CellphoneInput'

export default {
  name: 'ContactForm',

  components: {
    CellphoneInput
  },

  async created () {
    if (this.mode === 'edit') {
      this.loading = true
      await this.getContact()
    }

    if (!this.form.country) {
      this.form.country = this.account.country
    }
  },

  props: {
    mode: {
      type: String
    }
  },

  computed: {
    ...mapGetters(['account'])
  },

  data () {
    return {
      loading: false,
      submitting: false,
      form: {
        name: '',
        email: '',
        cellphone: '',
        country: ''
      }
    }
  },

  methods: {
    handleCellphoneInput (number, country) {
      this.form.cellphone = number
      this.form.country = country.iso2
    },

    handleSubmit () {
      if (this.mode === 'create') {
        this.createContact()
      } else {
        this.saveContact()
      }
    },
    
    async createContact () {
      try {
        this.submitting = true
        await this.$api.post(`account/${this.$route.params.account}/contacts`, this.form)
        await this.$store.dispatch('syncUser', this)
        this.$emit('success')
      } catch (error) {
        console.error(error)
      } finally {
        this.submitting = false
      }
    },

    async getContact () {
      try {
        const { data } = await this.$api.get(`account/${this.$route.params.account}/contacts/${this.$route.params.id}`)
        this.form = data.contact
        this.loading = false
      } catch (error) {
        console.error(error)
      }
    },

    async saveContact () {
      try {
        this.submitting = true
        await this.$api.patch(`account/${this.$route.params.account}/contacts/${this.$route.params.id}`, this.form)
        this.$store.dispatch('syncUser', this)
        this.$emit('success')
      } catch (error) {
        console.error(error)
      } finally {
        this.submitting = false
      }
    },

    async deleteContact () {
      if (window.confirm('Are you sure you want to delete this contact?')) {
        try {
          this.submitting = true
          await this.$api.delete(`account/${this.$route.params.account}/contacts/${this.$route.params.id}`)
          this.$store.dispatch('syncUser', this)
          this.$emit('success')
        } catch (error) {
          console.error(error)
        } finally {
          this.submitting = false
        }
      }
    }
  }
}
</script>